import { render } from "./expenses.vue?vue&type=template&id=cf1a3b52"
import script from "./expenses.vue?vue&type=script&lang=js"
export * from "./expenses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__